"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EntityBase_1 = require("./EntityBase");
class AggregateRootBase extends EntityBase_1.EntityBase {
}
exports.AggregateRootBase = AggregateRootBase;
//# sourceMappingURL=AggregateRootBase.js.map